import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { Button, Flex, Form, Input, notification } from 'antd';
import { useCallback, useState } from 'react';
import { Fragment } from 'react/jsx-runtime';
import { API } from '../../api';
import { notifyError } from '../../store/utils';

export const Login = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = useCallback(async (values: any) => {
    setLoading(true);
    try {
      await API.post({ apiVersion: 'api' })('/auth/login', values);
      window.location.href = '/dashboard';
    } catch (error: any) {
      console.log(error.message);
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <Fragment>
      <div className="login-container">
        <div className="form___3Tq4m">
          <div className="logo___3tfTW">
            <img alt="logo" src={'/images/logo.png'} />
          </div>
          <Flex justify="center">
            <div
              className="login-title"
              style={{ fontSize: 30, color: 'rgb(24, 144, 255)', fontWeight: 500 }}
            >
              Хүргэлтийн Систем
            </div>
          </Flex>
          <Flex justify="center">
            <span style={{ padding: 15 }}>Хүргэлтийн Цогц Систем</span>
          </Flex>
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{
              // email: 'admin@admin.com',
              // password: 'kkk',
              remember: true,
            }}
            onFinish={onFinish}
          >
            <Form.Item
              name="email"
              hasFeedback
              rules={[{ required: true, message: 'username is required' }]}
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="Username"
              />
            </Form.Item>
            <Form.Item
              name="password"
              hasFeedback
              rules={[{ required: true, message: 'password is required' }]}
            >
              <Input
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="Password"
              />
            </Form.Item>

            <Form.Item>
              <Button
                loading={loading}
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                Нэвтрэх
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </Fragment>
  );
};
